module.exports = __webpack_public_path__ + "static/media/class_job_035.da9d353d.svg";